<h2 mat-dialog-title>Create USPS Shipping Label</h2>
<mat-dialog-content>
  <form>
    <!-- From Address Section -->
    <h6 style="margin-top: 10px; margin-bottom: 15px; font-weight: bold; color: #1976d2;">From Address (Your Address)</h6>
    <div class="row mb-3">
      <div class="col-md-6">
        <mat-form-field appearance="outline" style="width: 100%;">
          <mat-label>First Name</mat-label>
          <input matInput [(ngModel)]="fromFirstName" name="fromFirstName" placeholder="First Name" required>
        </mat-form-field>
      </div>
      <div class="col-md-6">
        <mat-form-field appearance="outline" style="width: 100%;">
          <mat-label>Last Name</mat-label>
          <input matInput [(ngModel)]="fromLastName" name="fromLastName" placeholder="Last Name" required>
        </mat-form-field>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-md-12">
        <mat-form-field appearance="outline" style="width: 100%;">
          <mat-label>Street Address</mat-label>
          <input matInput [(ngModel)]="fromAddress.street" name="street" placeholder="Street Address" required>
        </mat-form-field>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-md-4">
        <mat-form-field appearance="outline" style="width: 100%;">
          <mat-label>City</mat-label>
          <input matInput [(ngModel)]="fromAddress.city" name="city" placeholder="City" required>
        </mat-form-field>
      </div>
      <div class="col-md-4">
        <mat-form-field appearance="outline" style="width: 100%;">
          <mat-label>State</mat-label>
          <mat-select [(ngModel)]="selectedFromState" name="state" placeholder="Select State" required
                      (selectionChange)="onFromStateChange($event.value)">
            <mat-option *ngFor="let state of statelist" [value]="state">
              {{ state.name }} ({{ state.stateCode }})
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-md-4">
        <mat-form-field appearance="outline" style="width: 100%;">
          <mat-label>ZIP Code</mat-label>
          <input matInput [(ngModel)]="fromAddress.zipCode" name="zipCode" placeholder="ZIP Code" maxlength="10" required>
          <mat-hint>5 or 9 digits</mat-hint>
        </mat-form-field>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-md-12">
        <mat-form-field appearance="outline" style="width: 100%;">
          <mat-label>Phone Number</mat-label>
          <input matInput [(ngModel)]="fromAddress.phone" name="phone" placeholder="Phone Number" required maxlength="15">
          <mat-hint>10-15 digits, numbers only</mat-hint>
        </mat-form-field>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-md-12">
        <mat-checkbox [(ngModel)]="saveFromAddress" name="saveFromAddress">
          Save this from address for future use
        </mat-checkbox>
      </div>
    </div>

    <!-- To Address Section -->
    <h6 style="margin-top: 20px; margin-bottom: 15px; font-weight: bold; color: #1976d2;">To Address (Recipient)</h6>
    <div class="row mb-2" *ngIf="!useDifferentToAddress">
      <div class="col-md-12">
        <div class="to-address-display">
          {{ getDefaultToAddressDisplay() }}
        </div>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-md-12">
        <mat-checkbox [(ngModel)]="useDifferentToAddress" name="useDifferentToAddress"
                      (change)="onUseDifferentToAddressChange($event.checked)">
          Ship to a different address
        </mat-checkbox>
      </div>
    </div>
    <div *ngIf="useDifferentToAddress">
      <div class="row mb-3">
        <div class="col-md-6">
          <mat-form-field appearance="outline" style="width: 100%;">
            <mat-label>Recipient First Name</mat-label>
            <input matInput [(ngModel)]="toFirstName" name="toFirstName" placeholder="First Name" required>
          </mat-form-field>
        </div>
        <div class="col-md-6">
          <mat-form-field appearance="outline" style="width: 100%;">
            <mat-label>Recipient Last Name</mat-label>
            <input matInput [(ngModel)]="toLastName" name="toLastName" placeholder="Last Name" required>
          </mat-form-field>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-12">
          <mat-form-field appearance="outline" style="width: 100%;">
            <mat-label>Street Address</mat-label>
            <input matInput [(ngModel)]="toAddress.street" name="toStreet" placeholder="Street Address" required>
          </mat-form-field>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-4">
          <mat-form-field appearance="outline" style="width: 100%;">
            <mat-label>City</mat-label>
            <input matInput [(ngModel)]="toAddress.city" name="toCity" placeholder="City" required>
          </mat-form-field>
        </div>
        <div class="col-md-4">
          <mat-form-field appearance="outline" style="width: 100%;">
            <mat-label>State</mat-label>
            <mat-select [(ngModel)]="selectedToState" name="toState" placeholder="Select State" required
                        (selectionChange)="onToStateChange($event.value)">
              <mat-option *ngFor="let state of statelist" [value]="state">
                {{ state.name }} ({{ state.stateCode }})
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-md-4">
          <mat-form-field appearance="outline" style="width: 100%;">
            <mat-label>ZIP Code</mat-label>
            <input matInput [(ngModel)]="toAddress.zipCode" name="toZipCode" placeholder="ZIP Code" maxlength="10" required>
          </mat-form-field>
        </div>
      </div>
    </div>

    <!-- Package Details Section -->
    <h6 style="margin-top: 20px; margin-bottom: 15px; font-weight: bold; color: #1976d2;">Package Details</h6>
    <div class="row mb-3">
      <div class="col-md-6">
        <mat-form-field appearance="outline" style="width: 100%;">
          <mat-label>Weight (oz)</mat-label>
          <input matInput type="number" [(ngModel)]="packageWeight" name="packageWeight" placeholder="Weight" min="0.01" step="0.01" required>
        </mat-form-field>
      </div>
      <div class="col-md-6">
        <mat-form-field appearance="outline" style="width: 100%;">
          <mat-label>Length (in)</mat-label>
          <input matInput type="number" [(ngModel)]="packageLength" name="packageLength" placeholder="Length" min="0.01" step="0.01" required>
        </mat-form-field>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-md-6">
        <mat-form-field appearance="outline" style="width: 100%;">
          <mat-label>Width (in)</mat-label>
          <input matInput type="number" [(ngModel)]="packageWidth" name="packageWidth" placeholder="Width" min="0.01" step="0.01" required>
        </mat-form-field>
      </div>
      <div class="col-md-6">
        <mat-form-field appearance="outline" style="width: 100%;">
          <mat-label>Height (in)</mat-label>
          <input matInput type="number" [(ngModel)]="packageHeight" name="packageHeight" placeholder="Height" min="0.01" step="0.01" required>
        </mat-form-field>
      </div>
    </div>

    <!-- USPS Service Type Checkboxes -->
    <div class="row mb-3">
      <div class="col-md-12">
        <h6 style="margin-top: 20px; margin-bottom: 15px; font-weight: bold; color: #1976d2;">USPS Service Type (Select one or more to check prices)</h6>
        <div class="usps-service-list">
          <mat-checkbox [(ngModel)]="selectedServiceTypes['Priority']" name="servicePriority">
            Priority Mail
          </mat-checkbox>
          <mat-checkbox [(ngModel)]="selectedServiceTypes['FirstClass']" name="serviceFirstClass">
            First-Class Package
          </mat-checkbox>
          <mat-checkbox [(ngModel)]="selectedServiceTypes['PriorityExpress']" name="servicePriorityExpress">
            Priority Mail Express
          </mat-checkbox>
          <mat-checkbox [(ngModel)]="selectedServiceTypes['GroundAdvantage']" name="serviceGroundAdvantage">
            USPS Ground Advantage
          </mat-checkbox>
          <mat-checkbox [(ngModel)]="selectedServiceTypes['ParcelSelect']" name="serviceParcelSelect">
            USPS Parcel Select
          </mat-checkbox>
          <mat-checkbox [(ngModel)]="selectedServiceTypes['ParcelSelectLightweight']" name="serviceParcelSelectLightweight">
            USPS Parcel Select Lightweight
          </mat-checkbox>
        </div>
      </div>
    </div>

    <!-- Label Format -->
    <div class="row mb-3">
      <div class="col-md-6">
        <mat-form-field appearance="outline" style="width: 100%;">
          <mat-label>Label Format</mat-label>
          <mat-select [(ngModel)]="labelFormat" name="labelFormat" [value]="labelFormat || 'PDF'">
            <mat-option value="PDF">PDF</mat-option>
            <mat-option value="TIFF">TIFF</mat-option>
            <mat-option value="SVG">SVG</mat-option>
            <mat-option value="JPG">JPG</mat-option>
            <mat-option value="ZPL203DPI">ZPL 203 DPI</mat-option>
            <mat-option value="ZPL300DPI">ZPL 300 DPI</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    
    <!-- Price Results Table -->
    <div *ngIf="priceResults.length > 0" class="row mb-3" style="margin-top: 20px;">
      <div class="col-md-12">
        <h6 style="margin-bottom: 15px; font-weight: bold; color: #1976d2;">Estimated Shipping Costs</h6>
        <div style="overflow-x: auto;">
          <mat-radio-group 
            [(ngModel)]="selectedServiceTypeForLabel"
            name="selectedServiceType"
            (change)="onServiceTypeSelected($event.value)">
            <table mat-table [dataSource]="priceResults" class="mat-elevation-z2" style="width: 100%;">
              <!-- Service Type Column -->
              <ng-container matColumnDef="serviceType">
                <th mat-header-cell *matHeaderCellDef>Service Type</th>
                <td mat-cell *matCellDef="let price">
                  <mat-radio-button 
                    [value]="price.serviceType" 
                    [disabled]="price.price === null">
                    {{ price.serviceTypeDisplay }}
                  </mat-radio-button>
                </td>
              </ng-container>

              <!-- Price Column -->
              <ng-container matColumnDef="price">
                <th mat-header-cell *matHeaderCellDef>Price</th>
                <td mat-cell *matCellDef="let price">
                  <span *ngIf="price.price !== null" style="font-size: 18px; font-weight: bold; color: #4caf50;">
                    ${{ price.price | number:'1.2-2' }}
                  </span>
                  <span *ngIf="price.price === null" style="color: #f44336;">
                    {{ price.error || 'N/A' }}
                  </span>
                </td>
              </ng-container>

              <!-- Description Column -->
              <ng-container matColumnDef="description">
                <th mat-header-cell *matHeaderCellDef>Description</th>
                <td mat-cell *matCellDef="let price">
                  <span *ngIf="price.description">{{ price.description }}</span>
                  <span *ngIf="!price.description && price.price === null" style="color: #999;">-</span>
                </td>
              </ng-container>

              <!-- Price Type Column -->
              <ng-container matColumnDef="priceType">
                <th mat-header-cell *matHeaderCellDef>Price Type</th>
                <td mat-cell *matCellDef="let price">
                  <span *ngIf="price.priceType">{{ price.priceType }}</span>
                  <span *ngIf="!price.priceType" style="color: #999;">-</span>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="['serviceType', 'price', 'description', 'priceType']"></tr>
              <tr mat-row *matRowDef="let row; columns: ['serviceType', 'price', 'description', 'priceType']"></tr>
            </table>
          </mat-radio-group>
        </div>
        <div *ngIf="selectedServiceTypeForLabel" style="margin-top: 15px; padding: 10px; background-color: #e3f2fd; border-radius: 4px; border: 1px solid #2196f3;">
          <strong>Selected for Label:</strong> {{ getServiceTypeDisplayName(selectedServiceTypeForLabel) }}
        </div>
      </div>
    </div>
    
    <!-- Price Error Display -->
    <div *ngIf="priceError && priceResults.length === 0" class="row mb-3" style="margin-top: 20px; padding: 15px; background-color: #ffebee; border-radius: 4px; border: 1px solid #f44336;">
      <div class="col-md-12">
        <div style="font-size: 14px; color: #c62828;">
          {{ priceError }}
        </div>
      </div>
    </div>
    <!-- Label Creation Error Display -->
    <div *ngIf="labelError" #labelErrorPanel id="label-error-panel" class="row mb-3 label-error-panel">
      <div class="col-md-12">
        <strong>Label creation failed</strong>
        <div class="label-error-text">{{ labelError }}</div>
      </div>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end" class="usps-label-actions">
  <button mat-button type="button" (click)="onCancel()">Cancel</button>
  <button mat-raised-button color="accent" type="button" (click)="onCheckPrice()"
          [disabled]="!isFromAddressValid() || !isToAddressValid() || !isPackageDetailsValid() || getSelectedServiceTypes().length === 0 || isCheckingPrice">
    <span *ngIf="!isCheckingPrice">Check Prices</span>
    <span *ngIf="isCheckingPrice">Checking...</span>
  </button>
  <button mat-raised-button color="primary" type="button" (click)="onSave()"
          [disabled]="!isFromAddressValid() || !isToAddressValid() || !isPackageDetailsValid() || !selectedServiceTypeForLabel || isCreatingLabel">
    <span *ngIf="!isCreatingLabel">Create Label</span>
    <span *ngIf="isCreatingLabel">Creating...</span>
  </button>
</mat-dialog-actions>

